
import { useOpenBaas } from "../Context/SdkBaasOpen";

function useIsLogin() {
  const { isLogin, setIsLogin } = useOpenBaas();
  return { isLogin, setIsLogin };
}

export default useIsLogin;
